export const addZeroToNumberBefore = (n: number) => {
  const prefix = n < 10 ? '0' : '';

  return `${prefix}${n}`;
};
